import { getSessionSaga, reduceLoading, reduceOperation } from 'metrix-common3';
import { call, put } from 'redux-saga/effects';
import { reducePolicyAdjustments } from '../../actions/policy/reducePolicyAdjustments';

export function* deletePolicyAdjustmentSaga(action) {
    try {
        yield put(reduceLoading({ code: 'deletePolicyAdjustment', value: true }));
        const session = yield getSessionSaga();

        const response = yield call(fetch, '/api/policyAdjustment/delete-adjustment', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                Accept: 'application/json',
                Authorization: session.authenticationToken.token,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(action.payload),
        });

        if (!response.ok) {
            console.error('Delete Policy Adjustment API failed with status:', response.status);
            yield put(reduceLoading({ code: 'deletePolicyAdjustment', value: false }));
            return;
        }

        const result = yield call([response, 'json']);

        // Add operation code to identify which operation completed
        yield put(reduceOperation({ ...result.operation, code: 'deletePolicyAdjustment' }));
        yield put(reducePolicyAdjustments(result));
        yield put(reduceLoading({ code: 'deletePolicyAdjustment', value: false }));
    } catch (error) {
        console.log('Error while calling Delete Policy Adjustment API - ', error);
        yield put(reduceLoading({ code: 'deletePolicyAdjustment', value: false }));
    } finally {
        yield put(reduceLoading({ code: 'deletePolicyAdjustment', value: false }));
    }
}
